import type {} from "@lit/react";
import { Markdown as MarkdownElement, } from "@vaadin/markdown/vaadin-markdown.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { MarkdownElement, };
export type MarkdownEventMap = Readonly<{}>;
const events = {} as MarkdownEventMap;
export type MarkdownProps = WebComponentProps<MarkdownElement, MarkdownEventMap>;
export const Markdown = createComponent({
    elementClass: MarkdownElement, events, react: React, tagName: "vaadin-markdown"
});
